import React from "react";

const VerifyButton = (props) => {
  const { handleVerified, btnName } = props;
  return (
    <>
      <button
        className="btn btn-light"
        style={{
          fontSize: "13px",
          backgroundColor: " rgb(220, 252, 231)",
          color: " rgb(122, 175, 159)",
          // paddingTop: "3px",
          // paddingBottom: "2px",
          // marginTop: "0px",
          // marginBottom: "0px",
          // paddingRight: "2px",
          // paddingLeft: "0px",
          // width: "76px",
          // borderRadius: 0,
          // fontFamily: "emoji",
          // fontWeight: "700",
          //   border: "1px solid",
        }}
        onClick={handleVerified}
      >
        <i class="bi bi-check-lg me-1"></i> {""}
        <span className="">{btnName ? btnName : "Verify"}</span>
      </button>
    </>
  );
};

export default VerifyButton;
